import type { BookingLine, BookingMoneyTotals } from '../pricing/pricingEngine';

export type BookingCommunicationSnapshot = {
  participantsCount: number;
  amount: number;
  bookingLines?: BookingLine[];
  moneyTotals?: Partial<BookingMoneyTotals>;
};

export function readBookingCommunicationSnapshot(
  source: Partial<BookingCommunicationSnapshot> | null | undefined,
): BookingCommunicationSnapshot | null {
  if (!source) return null;

  const participantsCount = Number(source.participantsCount);
  const amount = Number(source.amount);

  if (!Number.isFinite(participantsCount) || !Number.isFinite(amount)) {
    return null;
  }

  return {
    participantsCount: Math.max(0, participantsCount),
    amount,
    bookingLines: Array.isArray(source.bookingLines) ? source.bookingLines : undefined,
    moneyTotals: source.moneyTotals,
  };
}

export function resolveDisplayedBookingSnapshot({
  snapshot,
  legacyParticipantsCount,
  legacyAmount,
}: {
  snapshot: Partial<BookingCommunicationSnapshot> | null | undefined;
  legacyParticipantsCount: number;
  legacyAmount: number;
}): BookingCommunicationSnapshot | null {
  return (
    readBookingCommunicationSnapshot(snapshot) ||
    readBookingCommunicationSnapshot({
      participantsCount: legacyParticipantsCount,
      amount: legacyAmount,
    })
  );
}
